var map = {
	"./p1.png": 4184,
	"./p10.png": 2650,
	"./p11.png": 3411,
	"./p12.png": 8920,
	"./p13.png": 1633,
	"./p14.png": 8542,
	"./p15.png": 8535,
	"./p16.png": 9804,
	"./p17.png": 7317,
	"./p18.png": 6450,
	"./p19.png": 107,
	"./p2.png": 9795,
	"./p20.png": 4251,
	"./p3.png": 4234,
	"./p4.png": 4661,
	"./p5.png": 2396,
	"./p6.png": 8708,
	"./p7.png": 6830,
	"./p8.png": 6217,
	"./p9.png": 9968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3134;